<h2 mat-dialog-title>{{ 'admin_single_theme.dialog.title' | translate }}</h2>
<p>{{ 'admin_single_theme.dialog.descr' | translate: {theme_name: data.theme_name[data.current_lang]} }}</p>
<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button (click)="onNoClick()">{{ 'admin_single_theme.dialog.cancel' | translate }}</button>
    <button mat-button (click)="deleteTheme()" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_theme.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>